<template>
  <div>
    <log-list v-show="tabType === 1" @handleShow="handleShow" />
    <log-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import logList from './list'
import logShow from './show'
export default {
  components: { logList, logShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    },
  }


}
</script>

<style>
</style>